import { parseEther } from 'viem'

export const ZERO = 0n
export const ONE = 1n
export const TEN = 10n

/** User is discouraged to execute operation that would result in his LTV being above X% of the LLTV */
export const LTV_WARNING_THRESHOLD = parseEther('0.95')
export const LTV_AT_RISK_OF_LIQUIDATION_THRESHOLD = parseEther('0.9')
